var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-area-page" },
    [
      _c(
        "b-container",
        [
          _c("h1", [_vm._v("Berechtigungsprüfung")]),
          _vm._v(" "),
          _vm.confirmAgain
            ? [
                _c(
                  "p",
                  { staticClass: "font-weight-extra-bold color-primary" },
                  [_vm._v("Du hast ausgewählt:")]
                ),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.type.label))]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-5 d-flex align-items-center justify-content-end"
                  },
                  [
                    !_vm.confirming
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.abort.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("Abbrechen")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("Button", {
                      staticClass: "ml-4",
                      attrs: {
                        text: "Bestätigen",
                        icon: "checkmark",
                        disabled: !_vm.dataValid || _vm.confirming,
                        loading: _vm.confirming
                      },
                      on: { click: _vm.confirm }
                    })
                  ],
                  1
                )
              ]
            : [
                _c(
                  "p",
                  { staticClass: "font-weight-extra-bold color-primary" },
                  [
                    _vm._v(
                      "\n\t\t\t\tHöchster Datenschutz, Anonymität und Vertraulichkeit ist für alle Nutzer wichtig.\n\t\t\t\tDaher wird regelmäßig geprüft, ob alle User berechtigt sind, Suchen nach Bewerbern\n\t\t\t\tdurchzuführen.\n\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.companyName
                  ? _c("p", [
                      _vm._v("Bist du befugt, für "),
                      _c("b", { staticClass: "color-red" }, [
                        _vm._v(_vm._s(_vm.companyName))
                      ]),
                      _vm._v(" zu suchen?")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mb-3" },
                  [
                    _c("TreeSelect", {
                      attrs: {
                        characteristics: _vm.meta.customerSearchPermission
                      },
                      model: {
                        value: _vm.type,
                        callback: function($$v) {
                          _vm.type = $$v
                        },
                        expression: "type"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [
                  _c("b", [_vm._v("Hinweis:")]),
                  _vm._v(
                    " Falsche Angaben werden ohne Ausnahme direkt an die zuständigen Behörden\n\t\t\t\tzur Anzeige gebracht, führen zu Pönalzahlungen und zur Sperre des Accounts."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\t\t\t\tDie Eingaben werden gespeichert und an eine unabhängige Stelle weitergeleitet.\n\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-5 d-flex align-items-center justify-content-end"
                  },
                  [
                    !_vm.loggingOut
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.logout.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("Abbrechen (Abmelden)")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("Button", {
                      staticClass: "ml-4",
                      attrs: {
                        text: "Speichern",
                        icon: "checkmark",
                        disabled: !_vm.dataValid || _vm.loggingOut,
                        loading: _vm.loggingOut
                      },
                      on: { click: _vm.confirm }
                    })
                  ],
                  1
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }